
export function compute(itemTagsMap) {
    const edgeDict = getEdgeDict(itemTagsMap);
    
    const b1 = new Date();
    console.log('communities start', b1.getTime());
    // 2) create communities of tags
    const bestCommunities = computeOptCommunities(edgeDict, Object.keys(edgeDict));
    const b2 = new Date();
    console.log('communities end', b2.getTime());
    console.log('communities diff in seconds:', Math.abs(b1 - b2) / 1000);
    const m = {};
    const communities = [];

    const sorted = sortTags(itemTagsMap);
    bestCommunities.forEach(community => {
        const commKey = JSON.stringify(community[0]);
        if (!(commKey in m)) {
            m[commKey] = 1;
            const finalCommunity = community[0]
                .filter(tag => tag !== '#n::n::n')
                .sort((tag1, tag2) => sorted[tag1].idx > sorted[tag2].idx ? 1 : -1);
            communities.push(finalCommunity);
        }
    });
    return communities;
}

function computeOptCommunities(edgeDict, vertices) {
    let maxModularity = -Math.pow(10, 1000);
    let edgeSet = new Set();

    vertices.forEach(vertex => {
        edgeDict[vertex].forEach(vertex2 => {
            edgeSet = new Set([...edgeSet, ...[vertex, vertex2].sort()])
        })
    })

    const edgeCount = edgeSet.size;
    let updateGraph = structuredClone(edgeDict);

    let { betweenness, communities } = calculateBetweennessAndCommunities(edgeDict, vertices);
    let a1 = 0;
    let b1 = 0;
    let c1 = 0
    let count = 0
    while (true) {
        count++
        const aa0 = new Date();
        updateGraph = removeHighestBetweenEdge(updateGraph, betweenness);
        const aa1 = new Date();
        a1 += (Math.abs(aa0 - aa1) / 1000);
        
        const bb0 = new Date();
        const btwAndComm2 = calculateBetweennessAndCommunities(updateGraph, vertices);
        const bb1 = new Date();
        b1 += (Math.abs(bb0 - bb1) / 1000);
        ({ betweenness } = btwAndComm2);

        const cc0 = new Date();
        const currModularity = computeModularity(
            edgeDict, updateGraph, edgeCount, btwAndComm2.communities
        )
        const cc1 = new Date();
        c1 += (Math.abs(cc0 - cc1) / 1000);

        if (currModularity > maxModularity) {
            maxModularity = currModularity;
            communities = btwAndComm2.communities;
        } else {
            // print(f"modularity after split = {cur_modularity}, which is lower than best split {max_modularity}")
            break;
        }
    }

    console.log('loop count', count);
    console.log('time to remove between edge', a1);
    console.log('time to calculate betweenness', b1);
    console.log('time to compute modularity', c1);

    return communities
}

function scale_DAG_btw_dict(betweenness) {
    return Object.keys(betweenness).reduce((acc, key) => {
        acc[key] = betweenness[key] / 2
        return acc;
    }, {})
}

function defaultNodeScore(nodeScore, vertex, val, idx) {
        val = val || 0;
        if (!(vertex in nodeScore)) {
            nodeScore[vertex] = [0, 1]
        }
        nodeScore[vertex][idx] += val

        return nodeScore
    }

function calculateBetweennessAndCommunities(edgeDict, vertices) {
    let betweenness = {};
    const communities = new Set();

    vertices.forEach(vertex => {
        let visited = [];
        let src = [vertex]
        let nodeScore = {[vertex]: [1,1]};
        const edgePath = []
        const count = 0;

        while (true) {
            visited = [...visited, ...src];
            const nextSrc = new Set();
            const curLevelEdge = {};
            src.forEach(vertexInner => {
                const edge = edgeDict[vertexInner];
                edge.forEach(nextNode => {
                    const visitedSet = new Set([...visited]);
                    if (!visitedSet.has(nextNode)) {
                        nextSrc.add(nextNode);
                        nodeScore = defaultNodeScore(nodeScore, vertexInner, 0, 0);
                        nodeScore = defaultNodeScore(
                            nodeScore,
                            nextNode,
                            nodeScore[vertexInner][0],
                            0,
                        )

                        if (!(nextNode in curLevelEdge)) {
                            curLevelEdge[nextNode] = []
                        }
                        curLevelEdge[nextNode].push(vertexInner)
                    }
                })
            });

            if (nextSrc.size === 0) {
                if (!(vertex in edgeDict)) {
                    communities.add([vertex])
                } else {
                    communities.add([visited.sort()])
                }
                break;
            } else {
                edgePath.push(curLevelEdge)
                src = nextSrc
            }
        }

        // next, we compute the betweenness value and the edge credit to the next node
        for (var idx = edgePath.length-1; idx > -1; idx--) {
            const levelNodes = edgePath[idx];

            Object.keys(levelNodes).forEach(vertexInner => {
                const edges = levelNodes[vertexInner];
                edges.forEach(edge => {
                    const betweennessVal = nodeScore[vertexInner][1] * nodeScore[edge][0] / nodeScore[vertexInner][0];
                    // const betweennessVal = defaultNodeScore(nodeScore, vertex, 0, 1)[1] * defaultNodeScore(nodeScore, edge, 0, 0)[0] / defaultNodeScore(nodeScore, vertexInner, 0, 0)[0]
                    const val = [vertexInner, edge].sort()
                    if (!(val in betweenness)) {
                        betweenness[val] = 0
                    }

                    betweenness[val] += betweennessVal
                    nodeScore[edge][1] += betweennessVal
                })
            })
        }
    })

    betweenness = scale_DAG_btw_dict(betweenness)

    return {
        betweenness,
        communities,
    }
}

function getPermutations(array, size) {
    function p(t, i) {
        if (t.length === size) {
            result.push(t);
            return;
        }
        if (i + 1 > array.length) {
            return;
        }
        p(t.concat(array[i]), i + 1);
        p(t, i + 1);
    }

    var result = [];
    p([], 0);
    return result;
}

function computeModularity(
    originalGraph,
    updateGraph,
    edgeCount,
    communities,
) {
    let res = 0;
    communities.forEach(community => {
        getPermutations(community[0], 2).forEach(edge => {
            let A = 0;
            const [v1, v2] = edge;
            if (
                (originalGraph[v2].has(v1)) 
                && (originalGraph[v1].has(v2))
            ) {
                A = 1;
            }
            const ki = updateGraph[v1].size;
            const kj = updateGraph[v2].size;
            res += A - (ki*kj)/(2*edgeCount);
        })
    });

    return res/(2*edgeCount);
}

function removeHighestBetweenEdge(edgeDict, betweenness) {
    const sortedKeys = Object.keys(betweenness).sort((a, b) => betweenness[a] > betweenness[b] ? -1 : 1)
    const largestKey = sortedKeys && sortedKeys.length ? sortedKeys[0] : null;
    
    // TODO: don't know if this early return is correct. Should there always be a largestKey?
    // if (!largestKey) return edgeDict;

    const removeKeyList = Object.keys(betweenness)
        .filter(edgeKey => (
            parseFloat(betweenness[edgeKey].toFixed(5)) === parseFloat(betweenness[largestKey].toFixed(5))
        ))

    removeKeyList.forEach(key => {
        const keys = key.split(',');
        edgeDict[keys[0]].delete(keys[1]);
        edgeDict[keys[1]].delete(keys[0]);
    });

    return edgeDict;
}

export const sortTags = (itemTagsMap) => {
    // const tagsMap = { ...itemTagsMap, ...{ '#n::n::n': [] } };
    return Object.keys(itemTagsMap)
        // .filter(key => itemTagsMap[key].length > 1)
        .sort((keyA, keyB) => (
            itemTagsMap[keyA].length < itemTagsMap[keyB].length ? 1 : -1
        ))
        .reduce((acc, key, idx) => {
            acc[key] = {
                key,
                idx
            }
            return acc
        }, {})
}

// doc: https://medium.com/analytics-vidhya/girvan-newman-the-clustering-technique-in-network-analysis-part-2-a62dfdde11e
function getEdgeDict(itemTagsMap) {
    const m = {};

    // make map of item -> tags
    Object.keys(itemTagsMap).forEach(key => {
        const idStrings = itemTagsMap[key];
        idStrings.forEach(idString => {
            const itemId = parseItemId(idString);
            if (!(itemId in m)) {
                m[itemId] = [key];
            } else {
                m[itemId].push(key)
            }

            m[itemId].push('#n::n::n');
        })
    });

    // make map of tag -> neighbors
    const tagToNeighbors = {};
    Object.values(m).forEach(tags => {
        tags.forEach(tag => {
            if (!(tag in tagToNeighbors)) {
                tagToNeighbors[tag] = new Set([...tags]);
            } else {
                tagToNeighbors[tag] = new Set([...tagToNeighbors[tag], ...tags]);
            }
            tagToNeighbors[tag].delete(tag);
        })
    })

    return tagToNeighbors;
};

function parseItemId(idString) {
    return idString.split(':')[2];
};